import { render, staticRenderFns } from "./StandardPhraseModal.vue?vue&type=template&id=7967bc35&"
import script from "./StandardPhraseModal.vue?vue&type=script&lang=ts&"
export * from "./StandardPhraseModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports